import { createAction } from '@reduxjs/toolkit'

import { IXMetricsResponse, XMetricsActionTypes } from './types'

export const fetchXMetrics = createAction<number>(XMetricsActionTypes.FETCH_REQUEST)

export const fetchXMetricsSuccess = createAction(
  XMetricsActionTypes.FETCH_SUCCESS,
  (metrics: IXMetricsResponse, campaignId: number) => ({
    payload: {
      metrics,
      campaignId,
    },
  }),
)

export const fetchXMetricsError = createAction<any>(XMetricsActionTypes.FETCH_ERROR)
